import { DefaultFocusStatus } from "../../models/states/DefaultFocusStatus";
import { DEFAULT_FOCUS_STATUS } from "../actions";
import { ActionTypes } from "../actions/types";

export const INITIAL_STATE: DefaultFocusStatus = {
    statuses: [],
};

export const defaultFocusStatusReducer = (
    state = INITIAL_STATE,
    action: ActionTypes,
): DefaultFocusStatus => {
    if (action.type === DEFAULT_FOCUS_STATUS) {
        return INITIAL_STATE;
    }
    return state;
};
